import _, { times } from 'lodash'
import { getValueForMode } from '../constants/toUnits'

export const getFormRowsCount = (component, layoutMode) => {
  return ~~getValueForMode(component, layoutMode, ['props'], ['rows'], '3')
}

export const getFormColsCount = (component, layoutMode) => {
  const cols = ~~getValueForMode(component, layoutMode, ['props'], ['cols'], '2')
  return cols
}

const makeEmptyChildrenColumns = (cols, uidGEN, rowIndex) => {
  const children = {}
  times(cols, (index) => {
    const uid = `col_${rowIndex + 1}${String.fromCharCode('A'.charCodeAt(0) + index)}`
    children[uid] = {
      index,
      children: [],
    }
  })
  return children
}

export const makeEmptyChildrenStructure = (rows, cols, uidGEN) => {
  let children = {}

  times(rows, (rowIndex) => {
    const uid = `row_${rowIndex + 1}`
    children[uid] = {
      index: rowIndex,
      children: makeEmptyChildrenColumns(cols, uidGEN, rowIndex),
    }
  })

  return children
}
